const resources = {
    tryChangeFilters: 'Veuillez essayer de modifier certains de vos filtres pour afficher plus de résultats.',
    showMoreEvents: 'Afficher plus d’événements',
    of: 'de',
    results: 'Résultats',
    sortBy: 'Trier par',
    adjustFilters: 'Régler les filtres',
    noEventsMessage: 'We\'re sorry we couldn\'t find any events near you. Try changing your location or store to see more event results',
    changeLocation: 'Change location'
};

module.exports = function getResource(label) {
    return resources[label];
};
